import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=6f11341f&scoped=true&"
import script from "./orderAdd.vue?vue&type=script&lang=js&"
export * from "./orderAdd.vue?vue&type=script&lang=js&"
import style0 from "./orderAdd.vue?vue&type=style&index=0&id=6f11341f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11341f",
  null
  
)

export default component.exports